import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import HeaderWithBack from '../../components/Header/headerWithBack';
import { useTranslation } from 'react-i18next';
import { useCssStyle } from '../../customHook/getCssStyle';
import CustomCheckBoxWithProps from '../../components/checkBox/customCheckBox';
import { ImageComp } from '../../components/Image/Image';
import { getCleanUrl } from '../../utils/Helper';
import { useSelector } from 'react-redux';
import CustomPressable from '../../components/customPressable/customPressable';

const ListVenues = (props) => {
    const { selectedEvent, setSelectedVenue, selectedVenue, selectedInventory, setSelectedInventory, inventoryList, setInventoryList, handleNext, handleGoBack } = props;

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    
    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const doSetInventoryListCorrespondingVenue = (venueId) => {
        selectedEvent.events.find(event=>{
            if(event.venueId == venueId){
                    setInventoryList(event.inventories);
                    setSelectedInventory(null);
                return true;
            }
            return false;
        })
    }


    const renderHeader = () => {
        return <View style={getStyles(['widgetmainContainerHeaderContainer', 'reservationsHeaderContainer'])}>
        {
            currentWidget?.widgetHeaderImageUrl &&
            <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'reservationsHeaderImg'])} />
        }
        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'reservationsHeaderTitleContainer'])}>
            <Text style={getStyles(['widgetmainContainerHeaderTitle', 'reservationsHeaderTitle'])}>{t('events.heading3')}</Text>
        </View>
        </View>
    }
    return (
        <View style={getStyles(['widgetRootContainer', 'reservationsRootContainer'])}>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />
                        
            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'reservationsMainContainer'])} 
                showsVerticalScrollIndicator={false}
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'reservationsMainContainerChildContainer', {gap: 30, marginTop: 16}])}>

                    <View style={getStyles(["reservationsListMainContainer"])} id='reservationsListMainContainer'>
                        {selectedEvent?.events && Array.isArray(selectedEvent.events) && selectedEvent.events.length > 0 && 
                            <Text style={getStyles(["label"])} id='label'>Available Venues</Text>
                        }
                        
                        {selectedEvent?.events && Array.isArray(selectedEvent.events) && selectedEvent.events.length > 0 ? 
                            selectedEvent?.events?.map((event, index) =>  
                                <View key={index} style={getStyles(['list_itemContainer', "reservationsItemContainer"])}>
                                    {/* <View key={index} style={getStyles(['checkboxContainer'])}> */}
                                        <CustomCheckBoxWithProps
                                            value={selectedVenue == JSON.stringify({ venueId: event.venueId, venueName: event.venueName })}
                                            onValueChange={(value) => {
                                                setSelectedVenue(JSON.stringify({ venueId: event.venueId, venueName: event.venueName }));
                                                setSelectedInventory(null);
                                                doSetInventoryListCorrespondingVenue(event.venueId)
                                            }}
                                            checkBoxStyle={getStyles(["checkBox"])}
                                        />
                                        <View style={getStyles(["list_itemContainer_textContainer", "reservationsItemTxtContainer"])}>
                                            <Text style={getStyles(["list_itemContainer_textContainer_title", "reservationsItemTxtContainerTitle"])}>{event.venueName}</Text>
                                        </View>
                                    {/* </View> */}
                                </View>)
                        : <View style={getStyles(["reservationsNoReservationErrorContainer"])} >
                            <Text style={getStyles(["reservationsNoReservationError"])}>{selectedEvent?.events ? t("events.venue_not_available") : t("events.error.error")}</Text>
                        </View>}
                    </View>
                    
                    <View style={getStyles(["reservationsListMainContainer"])} id='reservationsListMainContainer'>
                        {selectedVenue && inventoryList && Array.isArray(inventoryList) && inventoryList.length > 0 && 
                            <Text style={getStyles(["label"])} id='label'>Available Sub-Events</Text>
                        }
                        {selectedVenue && inventoryList && Array.isArray(inventoryList) && inventoryList.length > 0 ? 
                            inventoryList?.map((inventory, index) =>  <View key={index} style={getStyles(['list_itemContainer', "reservationsItemContainer"])}>
                                <CustomCheckBoxWithProps
                                    value={selectedInventory == JSON.stringify(inventory)}
                                    onValueChange={(value) => {
                                        setSelectedInventory(JSON.stringify(inventory));
                                        doSetInventoryListCorrespondingVenue(inventory)
                                    }}
                                    checkBoxStyle={getStyles(["checkBox"])}
                                />
                                <View style={getStyles(["list_itemContainer_textContainer", "reservationsItemTxtContainer"])}>
                                    <Text style={getStyles(["list_itemContainer_textContainer_title", "reservationsItemTxtContainerTitle"])}>{inventory.inventory_name}</Text>
                                    <Text style={getStyles(["list_itemContainer_textContainer_subtitle", "reservationsItemTxtContainerSubtitle"])}>{`${currencyCode} ${inventory.price}`}</Text>
                                </View>
                            </View>) : null}
                        {/* // : <View style={getStyles(["reservationsNoReservationErrorContainer"])}>
                        //     <Text style={getStyles(["reservationsNoReservationError"])}>{selectedEvent?.events ? t("events.inventory_not_available") : t("events.error.error")}</Text>
                        // </View>} */}
                    </View>

                </View>
            </ScrollView>

            <View id='reservationsNextButtonContainer' style={getStyles(['reservationsNextButtonContainer'])}>
                <CustomPressable style={getStyles(["primaryBtn"])} disabled={!selectedVenue  || !selectedInventory} onPress={()=> handleNext()} id="primaryBtn">
                    <Text style={getStyles(["primaryBtnTxt"])} id='primaryBtnTxt'>
                        {t("events.continue")}
                    </Text>
                </CustomPressable>

                <CustomPressable style={getStyles(["secondaryBtn"])} onPress={()=> handleGoBack()} id="secondaryBtn">
                    <Text style={getStyles(["secondaryBtnTxt"])} id='secondaryBtnTxt'>
                        {t("events.back")}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default ListVenues
